module.exports = __webpack_public_path__ + "img/104-ecuador.29cdaa6a.svg";